/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface InformacionAdicionalControllerEliminarArticulo$Params {

/**
 * UUID del artículo a eliminar
 */
  uuidArticulo: string;
}

export function informacionAdicionalControllerEliminarArticulo(http: HttpClient, rootUrl: string, params: InformacionAdicionalControllerEliminarArticulo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, informacionAdicionalControllerEliminarArticulo.PATH, 'delete');
  if (params) {
    rb.path('uuidArticulo', params.uuidArticulo, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

informacionAdicionalControllerEliminarArticulo.PATH = '/api/informacion-adicional/eliminar-articulo/{uuidArticulo}';
